<template>
  <div class="modal fade" ref="modalEl" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('instruction.unsavedChangesTitle') }}</h5>
        </div>
        <div class="modal-body">
          <p class="mb-0">{{ $t('instruction.unsavedChangesLeaveConfirm') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" @click="resolveLeave(true)">
            <font-awesome-icon :icon="['fas', 'right-from-bracket']" class="me-2" />
            {{ $t('action.discardAndLeave') }}
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="resolveLeave(false)">
            <font-awesome-icon :icon="['fas', 'xmark']" class="me-2" />
            {{ $t('action.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { Modal } from 'bootstrap';

const modalEl = ref<HTMLElement | null>(null);
let pendingResolver: ((leave: boolean) => void) | null = null;

const confirm = (): Promise<boolean> => new Promise((resolve) => {
  if (!modalEl.value) {
    resolve(true);
    return;
  }
  pendingResolver = resolve;
  Modal.getOrCreateInstance(modalEl.value).show();
});

const resolveLeave = (leave: boolean) => {
  if (modalEl.value) {
    Modal.getInstance(modalEl.value)?.hide();
  }
  const resolver = pendingResolver;
  pendingResolver = null;
  resolver?.(leave);
};

defineExpose({ confirm });
</script>
